import ViewModelBase from './viewModelBase';

/**
  PageBase should organise handling of:
  - Title
  - Meta Information
  - ...
*/
export default abstract class PageBase extends ViewModelBase {

}
